import Vue from 'vue'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios';

axios.defaults.baseURL = "http://localhost:8080"
Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  bindRequestInterceptor () {
    this.$http.interceptors.request.use((config) => {
      if (this.isAuthenticated()) {
        config.headers['Authorization'] = this.getToken()
      } else {
        delete config.headers['Authorization']
      }
      return config
    })
  },
  baseUrl: 'http://localhost:8080', // Your API domain
  providers: {
    twitter: {
      redirectUri: 'http://localhost:3000/#/',
    },
  }
})

export function isHome(auth, userId) {
  if (!isAuthenticated(auth))
    return false
  
  if (userId === auth.storage.getItem("user_id"))
    return true
  
  return false
}

// user_id && tokenが存在すればtrue
export function isAuthenticated(auth) {
  if (!auth.isAuthenticated())
    return false
  const userId = auth.storage.getItem("user_id")
  if (!userId)
    return false
  return true
}
